import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { EnergyBatteryScale } from '../interactions/EnergyBatteryScale.jsx'
import { CardHistoryBack } from '../interactions/CardHistoryBack.jsx'
import { useCardHistory } from '../interactions/useCardHistory.js'

const CARD_DEF = { id: 'prep-energy', icon: '⚡', label: 'Energy meter' }

/**
 * EnergyCard — 5-bar battery scale.
 * catalog #3, prep-energy. Reuses EnergyBatteryScale (1:1 match).
 */
export function EnergyCard({ card, value, onChange, disabled, ownerUserId }) {
  const { data: historyData, loading: historyLoading, error: historyError } = useCardHistory(card?.prepCardId ?? 'prep-energy', ownerUserId)

  const back = (
    <CardHistoryBack
      cardDef={CARD_DEF}
      entries={historyData?.entries ?? []}
      loading={historyLoading}
      error={historyError}
      onFlip={() => {}}
    />
  )

  return (
    <CardFrame
      kind="prep"
      icon="⚡"
      iconClass="moss"
      title="Energy meter"
      prompt="How is your energy today?"
      state={disabled ? 'locked' : value?.value != null ? 'filled' : 'empty'}
      back={back}
      data-testid="prep-card-prep-energy"
      className="prepcard"
    >
      <EnergyBatteryScale value={value} onChange={onChange} disabled={disabled} />
    </CardFrame>
  )
}
